interface PaginationProps {
  page: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const DynamicPagination = ({
  page,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) => {
  // Generate visible page numbers (like 1, 2, 3, ..., 12)
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  const handlePrev = (e: React.MouseEvent) => {
    e.preventDefault();
    if (page > 1) onPageChange(page - 1);
  };

  const handleNext = (e: React.MouseEvent) => {
    e.preventDefault();
    if (page < totalPages) onPageChange(page + 1);
  };

  const handlePageClick = (p: number | string, e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof p === "number" && p !== page) {
      onPageChange(p);
    }
  };

  return (
    <div className="d-flex justify-content-end pt-30">
      <nav className="atbd-page">
        <ul className="atbd-pagination d-flex">
          <li className="atbd-pagination__item">
            {/* Previous */}
            <a
              href="#"
              className="atbd-pagination__link pagination-control"
              onClick={handlePrev}
            >
              <span className="la la-angle-left"></span>
            </a>

            {/* Page Numbers */}
            {pageNumbers.map((p, index) => (
              <a
                key={index}
                href="#"
                className={`atbd-pagination__link ${
                  p === page ? "active" : ""
                } ${p === "..." ? "pagination-control" : ""}`}
                onClick={(e) => handlePageClick(p, e)}
              >
                <span className="page-number">{p}</span>
              </a>
            ))}

            {/* Next */}
            <a
              href="#"
              className="atbd-pagination__link pagination-control"
              onClick={handleNext}
            >
              <span className="la la-angle-right"></span>
            </a>

            <a href="#" className="atbd-pagination__option"></a>
          </li>

          {/* Page Size Dropdown */}
          <li className="atbd-pagination__item">
            <div className="paging-option">
              <select
                name="page-number"
                className="page-selection"
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
              >
                <option value="10">10/page</option>
                <option value="20">20/page</option>
                <option value="30">30/page</option>
              </select>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default DynamicPagination;
